export const bubbleHeight = 94;
export const bubbleDuration = 5000;
